











import { computed, defineComponent } from '@nuxtjs/composition-api';

import { useLatestNews } from '@/composables/latest-news';

export default defineComponent({
  name: 'KeepReading',
  props: {
    currentArticleId: {
      type: String,
      default: '',
      required: true,
    },
    backgroundColor: {
      type: String,
      default: 'primary',
      required: false,
    },
  },
  setup: (props) => {
    const { latestNews, latestNewsLoading } = useLatestNews({ limit: 8 });
    const filteredNews = computed(() => latestNews.value.filter(article => article.id !== props.currentArticleId));

    return ({
      latestNews,
      latestNewsLoading,
      filteredNews,
    });
  },
});
